var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('TextField',_vm._g(_vm._b({attrs:{"value":_vm.displayDate || _vm.date,"disabled":_vm.disabled,"small":_vm.small,"append-icon":"mdi-calendar","readonly":"","label":_vm.label}},'TextField',attrs,false),on))]}}]),model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-date-picker',{attrs:{"value":_vm.date,"scrollable":"","min":_vm.min,"max":_vm.max},on:{"input":function (value) {
			_vm.$emit('update:date', value)
			_vm.modal = false
		}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }